<template>
  <div>
    <v-layout wrap v-if="isFetchingNbOfDossiersUsedByUserDuringCurrentBillingPeriod" justify-center>
      <v-flex xs6 mt-12>
        <v-progress-linear indeterminate color="primary" />
      </v-flex>
    </v-layout>
    <v-layout v-else-if="isMaxNbOfDossiersReachedForThisUser" wrap justify-center mt-12>
      <v-flex xs12 sm9>
        <h1>
          {{ $t('a') }}
        </h1>
      </v-flex>
      <v-flex xs11 sm6 text-center>
        <img :src="images.noMoreDossiers" height="200px" class="mb-4 mt-8"/>
        <v-card class="px-6 py-6 ">
          <div><b>{{ $t('z1') }} {{ user.company.maxNbOfDossiersPerUser }} {{ $t('z2') }}</b></div>
          <div><b><small>{{ $t('z3') }} {{ (new Date(user.company.currentMonthlyPeriodDates.endDate * 1000)).toLocaleDateString() }}</small></b></div>
          <div class="text-left">
            <small>
              <div class="mt-6">{{ $t('z4') }}</div>
              <div v-if="companyAdmins.length > 0" class="mt-2">
                <div>{{ $t('z5') }}</div>
                <div>{{ companyAdmins.map(admin => admin.email).join(', ') }}.</div>
              </div>
            </small>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout v-else wrap justify-center mt-12>
      <v-flex xs12 sm9>
        <h1>
          {{ $t('a') }}
        </h1>
        <!-- <div>
          <v-checkbox v-model="isUsingParserV2" style="margin-top: 0px" outlined dense hide-details color="orange">
            <template v-slot:label>
              <v-tooltip bottom dark>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <small class="primary--text">{{ $t('beta1') }}</small>
                    <v-icon class="ml-1" color="primary" small>mdi-information</v-icon>
                  </div>
                </template>
                <small v-html="$t('infoTooltipContent')"/>
              </v-tooltip>
            </template>
          </v-checkbox>
        </div> -->
        <div class="text-end">
          <v-btn small v-if="isUsingLinkedinCv" @click="isUsingLinkedinCv = false" outlined>
            <v-icon small class="mr-2">mdi-file</v-icon>
            {{ $t('x1') }}
          </v-btn>
          <v-btn small v-else @click="isUsingLinkedinCv = true" outlined>
            <v-icon small class="mr-2">mdi-linkedin</v-icon>
            {{ $t('x2') }}
          </v-btn>
        </div>
        <div class="text-end mt-6">
          <v-btn small @click="isShowingInviteConsultantDialog = true" outlined>
            <v-icon small class="mr-2">mdi-link-variant</v-icon>
            {{ $t('y1') }}
          </v-btn>
        </div>

        <v-layout wrap>
          <v-flex xs12 text-center>
            <img v-if="isUsingLinkedinCv" :src="images.linkedin" height="170px" class="mb-4"/>
            <img v-else :src="images.resume" height="190px" class="mb-4 mt-6"/>
          </v-flex>
        </v-layout>

        <v-flex xs12 v-if="isUsingLinkedinCv">
          <v-layout wrap justify-center>
            <v-flex xs12 sm8>
              <b>{{ $t('x3') }}</b>
              <br><small>{{ $t('x4') }}</small>
            </v-flex>
            <v-flex xs12 text-center>
              <img :src="user.data.locale === 'en' ? images.downloadLinkedinProfilePdfEn : images.downloadLinkedinProfilePdfFr" height="120px" class="mt-4 mb-4"/>
            </v-flex>
            <v-flex xs12 sm8 text-left mt-4 mb-2>
              <b>{{ $t('x5') }}</b>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout wrap justify-center>
          <v-flex xs8>
            
            <!-- <v-layout wrap>
              <v-flex xs12 text-center>
                <small class="red--text">
                  {{ $t('warningTechnicalProblems') }}
                </small>
              </v-flex>
            </v-layout> -->

            <v-layout wrap mt-2>
              <v-flex xs12>
                <v-form>
                  <v-layout v-if="showProgress" text-center justify-center row wrap>
                    <v-flex xs12 class="mt-2">
                      <progress id="uploader" value="0" max="100"></progress>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center text-center class="pb-2 px-3 mb-12">
                    <v-flex xs12 v-if="!uploadSuccess && !showProgress">
                      <v-btn class="upload-btn-wrapper secondary">
                        <!-- <v-icon class="mr-1">mdi-file-outline</v-icon> -->
                        <span v-if="isUsingLinkedinCv">{{ $t('bbis') }}</span>
                        <span v-else>{{ $t('b') }}</span>
                        <input id="fileButton" type="file" value="upload" class="hidden" :accept="isUsingLinkedinCv ? '.pdf' : '.doc,.docx,.pdf'"/>
                      </v-btn>
                      <div class="mt-2 grey--text">
                        <small v-if="isUsingLinkedinCv">.pdf</small>
                        <small v-else>.pdf .docx .doc</small>
                      </div>
                    </v-flex>
                    <v-flex xs12>
                      <span v-if="uploadError" class="red--text">{{ $t('c') }}</span>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-layout wrap text-center>
                  <v-flex xs12>
                    <v-dialog v-model="isCreateDossierPending" width="40%" persistent content-class="vDialogWithoutShadow">
                      <v-layout wrap mb-6>
                        <v-flex xs12 text-center>
                          <v-avatar :size="225" color="primary">
                            <img :src="images.robot">
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                      <v-card class="px-6 pb-4 pt-4 text-center primary white--text">
                        <div><b>{{ $t('d') }}</b></div>
                        <!-- <div v-if="isUsingParserV2"><small>{{ $t('d2') }}</small></div> -->
                        <v-progress-linear indeterminate color="secondary" class="mt-3"></v-progress-linear>
                        <div class="mt-2"><small>{{ timeToDisplay }} s</small></div>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isShowingInviteConsultantDialog" width="60%" :persistent="isInvitingConsultant">
      <v-card class="px-6 pb-6 pt-6">
        <div v-if="showErrorConsultantWasAlreadyInvited">
          <v-layout wrap>
            <v-flex xs12 text-center>
              <div class="orange--text">{{ $t('y2') }}</div>
              <div>{{ $t('y3') }}</div>
              <div class="mt-2">
                <v-btn small :to="`/dossiers?isShowingAllDossiersOfTheCompany=1&q=${encodeURIComponent(emailAddressOfConsultantToInvite)}`" class="primary">{{ $t('y4') }}</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </div>
        <div v-else-if="!isInvitingConsultant">
          <v-layout wrap>
            <v-flex xs12 text-center>
              <img :src="images.sendEmail" height="170px" class="mb-4"/>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 text-center>
              <h3>{{ $t('y5') }}</h3>
              <div>
                <small>
                  <ul class="text-left mt-2 mx-12">
                    <li>{{ $t('y7') }}</li>
                    <li>{{ $t('y8') }}</li>
                  </ul>
                  <div class="mt-8 mb-2"><b>{{ $t('w1') }}</b></div>
                </small>
              </div>
            </v-flex>

            <v-flex xs12 mt-4 px-12>
              <v-tabs v-model="activeInviteConsultantTab" fixed-tabs>
                <v-tab href="#byCode">
                  {{ $t('w3') }}      
                </v-tab>
                <v-tab href="#byEmail">
                  {{ $t('w2') }}
                </v-tab>
              </v-tabs>
              <v-divider/>

              <v-tabs-items v-model="activeInviteConsultantTab" class="mt-4">
                <v-tab-item value="byCode">
                  <v-layout wrap>
                    <v-flex xs12 mt-2 text-center>
                      <small>
                        <div class="mb-2"><i>{{ $t('w4') }}</i></div>
                        <div><b>{{ $t('w5') }}</b></div>
                      </small>
                    </v-flex>
                    <v-flex xs12 mt-6 text-center>
                      <v-chip>
                        <v-avatar left><v-icon small>mdi-link-variant</v-icon></v-avatar>
                        <div style="cursor: text; font-size: 0.9em"><b>{{ urlToInviteAnyConsultant }}</b></div>
                      </v-chip>
                      <div class="mt-6 mb-4"><small>{{ $t('w6') }}</small></div>
                    </v-flex>
                  </v-layout>
                </v-tab-item>

                <v-tab-item value="byEmail">
                  <v-layout wrap>
                    <v-flex xs12 mt-2 text-center>
                      <small>
                        <div class="mb-1"><i>{{ $t('w7') }}</i></div>
                        <div><b>{{ $t('y6') }}</b></div>
                      </small>
                    </v-flex>
                    <v-flex xs12 mt-5>
                      <v-layout wrap justify-center>
                        <v-flex xs12 sm8 text-center>
                          <v-text-field v-model="emailAddressOfConsultantToInvite" type="email" dense outlined :label="$t('y8bis')" autocomplete="off"/>
                          <v-btn @click="inviteConsultant" class="primary mb-3" :disabled="!isEmailAddressOfConsultantToInviteOk(emailAddressOfConsultantToInvite)">{{ $t('y9') }}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </div>
        <div v-else>
          <v-layout wrap>
            <v-flex xs12 text-center>
              <div class="mb-2"><b>{{ $t('y10') }}</b></div>
              <v-progress-linear indeterminate color="primary"></v-progress-linear> 
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    isCreateDossierPending: false,
    uploadedFileUrl: null,
    uploadSuccess: false,
    uploadError: false,
    showProgress: false,
    images: {
      linkedin: require('@/assets/app/images/linkedin_flatline.svg'),
      resume: require('@/assets/app/images/personal_data__flatline.svg'),
      downloadLinkedinProfilePdfFr: require('@/assets/app/images/download-linkedin-profile-pdf-fr.png'),
      downloadLinkedinProfilePdfEn: require('@/assets/app/images/download-linkedin-profile-pdf-en.png'),
      robot: require('@/assets/app/images/artificial_intelligence_flatline1.svg'),
      sendEmail: require('@/assets/app/images/Sent_messages _Flatline.svg'),
      noMoreDossiers: require('@/assets/app/images/data_organization_flatline.svg'),
    },
    isUsingLinkedinCv: false,
    isShowingInviteConsultantDialog: false,
    emailAddressOfConsultantToInvite: '',
    isInvitingConsultant: false,
    showErrorConsultantWasAlreadyInvited: false,
    isMaxNbOfDossiersReachedForThisUser: false,
    isFetchingNbOfDossiersUsedByUserDuringCurrentBillingPeriod: false,
    companyAdmins: [],
    activeInviteConsultantTab: 'byCode',
    isUsingParserV2: true,
    timer: null,
    lastCreateDossierStartedAt: null,
    timeToDisplay: null
  }),
  async mounted() {
    await this.waitForCompanyToBeLoaded()
    if (this.user.company.isMaxNbOfDossiersPerUserEnabled) {
      this.isFetchingNbOfDossiersUsedByUserDuringCurrentBillingPeriod = true
      this.isMaxNbOfDossiersReachedForThisUser = await this.getIsMaxNbOfDossiersReachedForThisUser()
      this.isFetchingNbOfDossiersUsedByUserDuringCurrentBillingPeriod = false
    }
    if (!this.isMaxNbOfDossiersReachedForThisUser) {
      setTimeout(() => {
        this.initFileUploadButton()
      }, 1)
    } else {
      this.companyAdmins = (await this.$functions.httpsCallable('getAdminsOfMyCompany')()).data.admins.filter(admin => admin.companyId === this.user.data.companyId)
    }
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    urlToInviteAnyConsultant() {
      return `https://esnwebservices.com/consultant/invitation-code/${this.user.company.codeToInviteAnyConsultant}`
    }
  },
  methods: {
    async waitForCompanyToBeLoaded() {
      const user = this.user
      if (!user.data || (user.data.companyId && user.company === null)) {
        await this.sleep(100);
        await this.waitForCompanyToBeLoaded()
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async getIsMaxNbOfDossiersReachedForThisUser() {
      const { nbOfDossiersUsedByUserDuringCurrentBillingPeriod } = (await this.$functions.httpsCallable('getNbOfDossiersUsedByUserDuringCurrentBillingPeriod')()).data
      return nbOfDossiersUsedByUserDuringCurrentBillingPeriod >= this.user.company.maxNbOfDossiersPerUser
    },
    updateTime() {
      if (this.isCreateDossierPending) {
        this.timeToDisplay = Math.floor( (Date.now() - this.lastCreateDossierStartedAt) / 1000)
      }
    },
    async createFromFileUpload() {
      this.isCreateDossierPending = true
      this.lastCreateDossierStartedAt = Date.now()
      this.timer = setInterval(this.updateTime, 100);
      const dataToSend = {
        sourceUrl: this.uploadedFileUrl,
        templateId: null,
        isTranslationAccepted: false,
        isUsingParserV2: this.isUsingParserV2
      }
      const dossierId = (await this.$functions.httpsCallable('createDossier', { timeout: 540 * 1000 })(dataToSend)).data.dossierId
      // Wait for processing to be done and then redirect
      const _this = this;
      let unsubcribeFirebaseDossierListener;
      unsubcribeFirebaseDossierListener = this.$db.collection('dossiers').doc(dossierId).onSnapshot(dossierSnap => {
        const dossier = dossierSnap.data();
        if (dossier.isProfileReady) {
          if (unsubcribeFirebaseDossierListener) unsubcribeFirebaseDossierListener();
          if (this.timer) clearInterval(this.timer);
          _this.$router.push(`/dossiers/${dossierId}/edit`)
        }
        if (dossier.status === 'error') {
          if (unsubcribeFirebaseDossierListener) unsubcribeFirebaseDossierListener();
          if (this.timer) clearInterval(this.timer);
          setTimeout(() => {
            _this.$router.push(`/dossiers`)
          }, 10000)
        }
      })
    },
    initFileUploadButton() {
      const _this = this;
      const fileButton = document.getElementById('fileButton');

      fileButton.addEventListener('change', function(e) {
        _this.showProgress = true;
        _this.uploadSuccess = false;
        _this.uploadError = false;

        // Get file
        const file = e.target.files[0];

        // Create a storage ref
        const date = new Date().toISOString();
        const fileName = `${file.name.replace(/[^a-zA-Z0-9]+/g, "-")}--${date}`
        const tmpNameArr = fileButton.value.toString().split('.')
        const fileExtension = tmpNameArr[tmpNameArr.length - 1]
        const filePath = `dossiersToAdapt/${fileName}.${fileExtension}`
        const storageRef = _this.$storage.ref(filePath);
        
        // Upload file
        const task = storageRef.put(file);

        // Update progress bar
        task.on('state_changed',
          function progress(snapshot) {
            const percentage = snapshot.totalBytes !== 0 ? Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100) : 0;
            const uploader = document.getElementById('uploader');
            uploader.value = percentage;
          },
          function uploadError() {
            _this.uploadError = true;
            _this.showProgress = false;
          },
          function complete() {
            _this.uploadSuccess = true;
            _this.showProgress = false;
            _this.uploadedFileUrl = filePath
            _this.createFromFileUpload()
          }
        )
      })
    },
    isEmailAddressOfConsultantToInviteOk(email) {
      email = email.trim()
      if (!email || !/.+@.+\..+/.test(email)) return false
      return true
    },
    async inviteConsultant() {
      this.isInvitingConsultant = true
      const response = await this.$functions.httpsCallable('inviteConsultant')({
        invitedConsultantEmail: this.emailAddressOfConsultantToInvite
      })
      if (response.data && response.data.errorCode === 'consultant-was-already-invited-to-create-a-dossier') {
        this.showErrorConsultantWasAlreadyInvited = true
        this.isInvitingConsultant = false
      } else {
        this.$router.push('/dossiers')
      }
    }
  }
}
</script>

<style scoped>
  .switch-center {
    display: flex;
    justify-content: center;
  }
</style>

<i18n>
{
  "fr": {
    "a": "Créer un nouveau dossier de compétences",
    "b": "Uploader un CV",
    "bbis": "Uploader le CV LinkedIn",
    "c": "Erreur lors de l'upload.",
    "d": "Analyse du CV en cours...",
    "d2": "La nouvelle version est plus précise mais peut prendre une petite minute pour les longs CVs.",
    "infoTooltipContent": "<ul><li>La nouvelle version est bien plus efficace pour les CVs courts et visuellement complexe.</li><li>Elle donne aussi accès à un nouveau module de gestion des compétences techniques.</li><li>Elle est cependant plus lente et parfois moins efficace sur les longs CVs classiques type dossiers de compétences.</li><li>Choisissez la version qui correspond le mieux au CV que vous allez uploader !</li></ul>",
    "5": "Choisir le template",
    "5bis": "Utiliser le template par défaut",
    "6": "Quel template souhaitez-vous utiliser ?",
    "7": "Template",
    "translationLabel1": "Traduire le contenu du CV en",
    "translationLabel2": "si besoin.",
    "FR": "Français",
    "EN": "Anglais",
    "DE": "Allemand",
    "ES": "Espagnol",
    "IT": "Italien",
    "PT": "Portugais",
    "NL": "Néerlandais",
    "RU": "Russe",

    "x1": "Utiliser un CV normal",
    "x2": "Utiliser un CV LinkedIn",
    "x3": "1 - Téléchargez au format PDF le profil depuis sa page LinkedIn",
    "x4": "Cliquez sur \"Plus\" puis \"Enregistrer au format PDF\".",
    "x5": "2 - Uploadez le fichier PDF téléchargé",

    "warningTechnicalProblems": "Nous avons quelques soucis techniques. Notre service sera à nouveau entièrement disponible d'ici quelques heures.",

    "y1": "Inviter un consultant à créer son dossier",
    "y2": "Invitation non envoyée.",
    "y3": "Le consultant avait déjà été invité à créer son dossier.",
    "y4": "Voir le dossier",
    "y5": "Inviter un consultant à créer lui-même son dossier de compétences",
    "y6": "Le consultant recevra un email explicatif.",
    "y7": "Invitez votre consultant à uploader son CV et éditer les informations de son profil dans le formulaire habituel.",
    "y8": "Rendez-vous ensuite dans la liste de dossiers de votre équipe pour le télécharger et éventuellement l'éditer.",
    "y8bis": "Adresse email du consultant",
    "y9": "Inviter",
    "y10": "Envoi de l'invitation en cours...",

    "z1": "Vous avez atteint votre plafond personnel de",
    "z2": "dossiers par mois",
    "z3": "Prochain renouvellement le",
    "z4": "Ce plafond a été mis en place par vos administrateurs pour répartir équitablement les dossiers entre les membres de votre équipe.",
    "z5": "Pour changer ce plafond, contactez les administrateurs de votre équipe :",

    "w1": "Vous pouvez inviter un consultant de 2 manières :",
    "w2": "Par email",
    "w3": "Avec un lien",
    "w4": "Utile pour envoyer un message commun à tous vos consultants.",
    "w5": "Copier le lien suivant et envoyez-le vous-même aux consultants.",
    "w6": "Toute personne avec ce lien pourra créer un dossier de compétences.",
    "w7": "Utile pour inviter un seul consultant.",

    "beta1": "Utiliser la nouvelle extraction de données en Beta."
  },
  "en": {
    "a": "Transform a new CV",
    "b": "Upload a CV",
    "bbis": "Upload the LinkedIn CV",
    "c": "An error occurred during the upload.",
    "d": "Analyzing CV...",
    "d2": "New version, slower but more precise, may take a minute for long resumes.",
    "infoTooltipContent": "<ul><li>The new version is way more efficient on short and visually complex resumes.</li><li>It also enables a new module to edit the technical skills.</li><li>It is however slower and sometimes less efficient on longer more standard resumes.</li><li>Choose accordingly!</li></ul>",
    "5": "Choose template",
    "5bis": "Use default template",
    "6": "Which template do you want to use ?",
    "7": "Template",
    "translationLabel1": "Translate CV's content to",
    "translationLabel2": "if needed.",
    "FR": "French",
    "EN": "English",
    "DE": "German",
    "ES": "Spanish",
    "IT": "Italian",
    "PT": "Portuguese",
    "NL": "Dutch",
    "RU": "Russian",

    "x1": "Use a normal CV",
    "x2": "Use a LinkedIn CV",
    "x3": "1 - Download a PDF CV from the LinkedIn profile page",
    "x4": "Click on \"More\", then on \"Save to PDF\".",
    "x5": "2 - Upload this downloaded PDF file",

    "warningTechnicalProblems": "We currently have a few technical problems. Our service will be fully available in a few hours.",

    "y1": "Invite a consultant to transform his CV himself",
    "y2": "Invitation was not sent.",
    "y3": "The consultant had already been invited to create his CV.",
    "y4": "See the CV",
    "y5": "Invite a consultant to transform his CV himself",
    "y6": "The consultant will receive an email with explanations.",
    "y7": "Invite your consultant to upload his CV and edit his profile data in the usual form.",
    "y8": "You will then be able to also edit this data if needed and download the new CV.",
    "y8bis": "Email address of the consultant",
    "y9": "Invite",
    "y10": "Sending invitation...",


    "z1": "You have reached the max number of",
    "z2": "CVs per user per month",
    "z3": "Next refill on",
    "z4": "This limit has been set up by your administrators to equally distribute the CVs between the members of the team.",
    "z5": "To change this limit, contact the administrators of your team :",


    "w1": "You have 2 ways to invite a consultant:",
    "w2": "By email",
    "w3": "With a link",
    "w4": "Useful to send a common message to all your consultants.",
    "w5": "Copy the following link and send it yourself to your consultants.",
    "w6": "Anyone with the link will be able to transform a CV.",
    "w7": "Useful to invite only one consultant.",

    "beta1": "Use the new data extraction in Beta."
  }
}
</i18n>

<style scoped>
.v-tooltip__content {
  background-color: #37474f;
  /* opacity: 1 !important; */
}
</style>